import { Pipe, PipeTransform } from '@angular/core';
import { split } from 'lodash';

@Pipe({
  name: 'split',
  standalone: true,
})
export class SplitPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    separator?: RegExp | string,
    limit?: number
  ): string[] {
    return split(value, separator, limit);
  }
}
